import { render, staticRenderFns } from "./BQ.vue?vue&type=template&id=02eafd52&scoped=true&"
import script from "./BQ.vue?vue&type=script&lang=js&"
export * from "./BQ.vue?vue&type=script&lang=js&"
import style0 from "./BQ.vue?vue&type=style&index=0&id=02eafd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eafd52",
  null
  
)

component.options.__file = "BQ.vue"
export default component.exports